import styled from "styled-components";

export const StyledChangeLogsTile = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  height: 100%;
`;

export const ChangeLogsTileHeader = styled.h2`
  font-size: 14px;
  font-weight: 500;
  display: grid;
  gap: 4px;
  align-items: center;
  margin: 0;
  padding: 8px;
  border-radius: 4px;
  background-image: linear-gradient(
    95deg,
    rgba(0, 0, 0, 1) 3%,
    rgba(45, 44, 44, 1) 86%
  );
  color: ${({ theme }) => theme.colors.white};

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 13px;
  }
`;

export const ChangeLogsListMain = styled.ul`
  margin: 0;
  padding: 8px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 1px 2px 24px -16px rgba(66, 68, 90, 1);
  overflow: scroll;
  overflow-x: hidden;
`;

export const ChangeLogsList = styled.ul`
  margin: 0;
  padding: 5px;
  display: grid;
`;

export const ChangeLogsListItem = styled.li`
  font-size: 13px;
  align-items: center;
  grid-gap: 5px;
  margin-bottom: 8px;
  align-items: start;
  line-height: 1.5;
  display: grid;
  grid-template-columns: 96px 1fr auto;

  @media (max-width: ${({ theme }) => theme.breakPoints.mobileMax}) {
    font-size: 12px;
  }
`;

export const ChangeLogsTileHeaderText = styled.span`
  display: block;
`;

export const ChangeLogsTileDescription = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.86);

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 11px;
  }
`;

export const ChangeLogsListItemDescription = styled.div`
  padding: 0;
  margin: 0;
  display: grid;
  gap: 10px;
  align-items: start;
`;

export const ChangeLogsListItemRepoName = styled.div`
  box-shadow: inset 0px 0px 10px 0px rgba(185, 185, 186, 1);
  border-radius: 3px;
  font-size: 10px;
  margin: 0;
  padding: 2px 6px;
  background-color: #f0f0f0;
  width: 90px;
  min-height: unset;
  text-align: left;
  display: grid;
  gap: 1px;
  align-content: start;
  line-height: 1.2;

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 8px;
  }
`;

export const VersionLabel = styled.span`
  font-weight: 700;
  color: ${({ $variant }) => {
    if ($variant === "dev") return "#a05a8f";
    if ($variant === "beta") return "#c97a1f";
    if ($variant === "prod") return "#2f7a46";
    if ($variant === "lts") return "#0f6d8a";
    return "#6f5aa8";
  }};
`;

export const ExeVersion = styled.div`
  font-size: 12px;
  justify-self: end;
  font-style: italic;
  justify-self: start;
  color: ${({ theme }) => theme.colors.shadyLady};  
`;

export const Link = styled.a`
  display: inline-block;
  text-decoration: none;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.seance};

  &:hover {
    cursor: pointer;
    font-weight: 500;
    transition: 0.3s;
    color: ${({ theme }) => theme.colors.codGrey};
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 11px;
  }
`;

export const ItemActions = styled.div`
  display: grid;
  gap: 4px;
  justify-items: end;
`;

export const FavoriteButton = styled.button`
  border: 1px solid ${({ theme, $isFavorite }) => ($isFavorite ? theme.colors.seance : "#c5c5c5")};
  background: ${({ theme, $isFavorite }) => ($isFavorite ? theme.colors.seance : "#ffffff")};
  color: ${({ theme, $isFavorite }) => ($isFavorite ? theme.colors.white : theme.colors.codGrey)};
  border-radius: 4px;
  width: 24px;
  height: 24px;
  padding: 0;
  cursor: pointer;
  display: grid;
  place-items: center;

  svg {
    font-size: 14px;
  }

  &:hover {
    opacity: 0.9;
  }
`;

export const StyledVersion = styled.p`
 font-size: 12px;
 margin: 5px;
 font-style: italic;
 color: ${({ theme }) => theme.colors.seance}; 
`;
